import { render } from "./DealerRoom.vue?vue&type=template&id=3f6e03c4&ts=true"
import script from "./DealerRoom.vue?vue&type=script&lang=ts"
export * from "./DealerRoom.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__